import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Container } from 'semantic-ui-react';
import * as yup from 'yup';
import { Checkbox } from 'formik-semantic-ui';


import AddTitleBar from '../../../titleBar/add_titleBar';

//Inputs
import { DateData } from '../../../formikInput/date';
import FileUpload from '../../../formikInput/uploadFile';

//Add-Product
import AddProduct from '../../../purchaseOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder'

//Dropdowns
import PurchaseOrderVendorDropdown from '../../../dropdowns/purchaseOrderVendorDropdown';
import BranchDropdown from '../../../dropdowns/branchDropdown';
import VehicleDropdown from '../../../dropdowns/vehicleDropdown';

//Actions 
import { getBills, updateBill } from '../../../../redux/actions/billActions';
import { getVendorPurchaseOrder } from '../../../../redux/actions/purchaseOrderActions';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder';


const AddBill = (props) => {

    const { getBills, updateBill, getVendorPurchaseOrder, vendorPurchaseOrderData, vendorPurchaseOrderLoading, billData, billLoading } = props;

    //State
    const [activateManualPO, setActivateManualPO] = useState(false);

    //UseEffect
    useEffect(() => {
        const id = props.location.state.id
        const vendorCode = props.location.state.vendorCode
        const edit = true
        getBills(id)
        getVendorPurchaseOrder(vendorCode, edit)
    }, [getBills])

    // if (vendorPurchaseOrderLoading || billLoading) {
    //     return (
    //         <React.Fragment>
    //             <LoadingPlaceholder />
    //         </React.Fragment>
    //     )
    // } else {

    //Existing PO Array

    let activePOData = [];

    vendorPurchaseOrderData && billData && vendorPurchaseOrderData.map((o, i) => {
        let temp = {}

        function containsPoId(obj, list) {
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].poId === obj.poId) {
                    return true;
                }
            }

            return false;
        }

        temp.checkbox = containsPoId(o, billData[0].bill_po_mapping)
        temp.poId = o.poId
        temp.poReferenceNo = o.poReferenceNo
        temp.vendorCode = o.vendorId
        temp.branchCode = o.branchId
        temp.vehicleNo = o.vehicleId
        temp.poQuantity = o.poQuantity
        temp.poAmount = o.poAmount
        temp.poNumber = o.poNumber
        temp.deliveryDate = o.deliveryDate ? o.deliveryDate : ''
        temp.sgstAmount = o.sgstAmount
        temp.cgstAmount = o.cgstAmount
        temp.igstAmount = o.igstAmount
        temp.adjustment = o.adjustment
        temp.totalOrderAmt = o.totalOrderAmt
        temp.remarks = o.remarks
        temp.gstTaxType = o.gstTaxType
        temp.poDate = o.poDate
        temp.tdsAmount = o.tdsAmount
        temp.taxableAmount = o.taxableAmount
        temp.totalDiscount = o.totalDiscount

        activePOData[i] = temp
    })


    //Formik
    const initialValues = {
        vendorName: billData ? billData[0].vendorCode : '',
        billNumber: billData ? billData[0].billNo : '',
        billDate: billData ? new Date(billData[0].billDate) : '',
        expectedPaymentDate: billData ? new Date(billData[0].expectedPaymentDate) : '',
        branch: billData ? billData[0].branchCode : '',
        billReferenceNo: billData ? billData[0].billReferenceNo : '',
        fileUpload: '',
        filePath: billData ? billData[0].filePath : '',
        isGstApplicable: billData && billData[0].isGstApplicable === 0 ? false : true,
        productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            quantity: '1',
            rate: '',
            discount: '',
            discountType: "1",
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: 9,
            cGst: 0,
            sGstPercent: 9,
            sGst: 0,
            amount: 0,
        }],
        activePODetails: activePOData,
        finalAmount: '',
        activePOSelected: [],
    }

    const validateSchema = yup.object().shape({
        vendorName: yup.mixed().required('Partner Name is Required'),
        billNumber: yup.mixed().required('Bill Number is Required'),
        billDate: yup.mixed().required('Bill Date is Required'),
        branch: yup.mixed().required('Branch is Required'),
        expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
        billReferenceNo: yup.mixed().required('Bill Reference Number is Required'),
    })

    const onSubmit = values => {
        console.log("Product Onsubmit", values)

        const customerNumber = localStorage.getItem('customerNumber');
        const userId = localStorage.getItem('userId');

        let psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.psCode = product.productCode
            temp.psName = product.productName
            temp.startDate = product.startDate
            temp.endDate = product.endDate
            temp.psQty = product.quantity
            temp.psPrice = product.rate
            temp.psAmount = product.rate * product.quantity
            temp.igstPercent = product.iGstPercent
            temp.igstAmount = product.iGst
            temp.cgstPercent = product.cGstPercent
            temp.cgstAmount = product.cGst
            temp.sgstPercent = product.sGstPercent
            temp.sgstAmount = product.sGst
            temp.tdsCode = 9
            temp.discount = product.discount
            temp.finalDiscount = product.discount
            temp.discountType = product.discountType
            temp.taxableAmount = product.rate * product.quantity
            psLineItems[index] = temp
        });

        let exLineItems = [];
        values.activePOSelected.map((product, index) => {
            let temp = {}
            temp.poReferenceNo = product.poReferenceNo
            exLineItems[index] = temp
        })

        let manualPoArray = [
            {
                poReferenceNo: values.poReferenceNo,
                vendorCode: values.vendorName,
                branchCode: values.vendorBranch,
                vehicleNo: values.vehicleNumber,
                poQuantity: psLineItems.length,
                poAmount: values.finalAmount,
                sgstAmount: 0,
                cgstAmount: 0,
                igstAmount: 0,
                adjustment: 0,
                totalOrderAmt: values.finalAmount,
                remarks: '',
                gstTaxType: 0,
                poDate: new Date(),
                tdsAmount: 0,
                taxableAmount: values.finalAmount,
                totalDiscount: 0,
                psDetails: psLineItems
            }
        ]

        if (activateManualPO) {
            exLineItems = [];
        } else {
            manualPoArray = [];
        }

        const updateBillData = {
            customerNo: customerNumber,
            userId: userId,
            billReferenceNo: '',
            billNo: values.billNumber,
            vendorCode: values.vendorName,
            billAmount: values.finalAmount,
            statusCode: '',
            expectedPaymentDate: values.expectedPaymentDate,
            fileUpload: values.fileUpload ? values.fileUpload.base64.split(',')[1] : '',
            billReferenceNo: values.billReferenceNo,
            billDate: values.billDate,
            totalPoAmount: values.finalAmount,
            termsConditions: '',
            remarks: '',
            branchCode: values.branch,
            gstTaxType: 2,
            totalTaxableAmount: 0,
            totalSgstAmount: 2,
            totalCgstAmount: 2,
            totalIgstAmount: 2,
            totalTdsAmount: 2,
            departMentCategoryCode: 0,
            irn: '',
            hsnCode: '',
            noOfLineItems: psLineItems.length,
            isPartialBill: 0,
            grn: '',
            grnDateTime: '',
            billReceiptDate: '',
            poDate: '',
            totalOrderAmt: values.finalAmount,
            adjustment: 0,
            poAmount: values.amount,
            isGstApplicable: values.isGstApplicable ? 1 : 0,
            poQuantity: 1,
            tdsAmount: '',
            taxableAmount: 2,
            totalDiscount: 0,
            existingPoArray: exLineItems,
            manualPoArray: manualPoArray,
        };

        console.log("Update Bill Data", updateBillData)
        // updateBill(updateBillData);

    };

    const handleDownload = () => {
        window.open(billData[0].filePath)
    }

    if (vendorPurchaseOrderLoading) {
        return (
            <div>Loading...</div>
        )
    } else {
        return (
            <React.Fragment>
                <AddTitleBar title="Edit Bill" LinkName="/bill" />
                <div className="m-2">
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}>
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form">
                                        <FormUi.Group >
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Partner Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik component={PurchaseOrderVendorDropdown} name="vendorName" placeholder="Partner Name" value={values.vendorName} disabled />
                                                {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Bill Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik name="billNumber" placeholder="Bill Number" readOnly />
                                                {touched.billNumber && errors.billNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billNumber}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Bill Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`billDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Date"
                                                    selected={values.billDate} x
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input error={values.billDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" value={values.branch} />
                                                {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Expected Payment Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`expectedPaymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Date"
                                                    selected={values.expectedPaymentDate}
                                                    minDate={values.billDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input error={values.expectedPaymentDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Bill Reference Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik name="billReferenceNo" placeholder="Reference Number" value={values.billReferenceNo} disabled />
                                                {touched.billReferenceNo && errors.billReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.billReferenceNo}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Re Upload Invoice</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="1">
                                                <Fieldmik component={FileUpload} name="fileUpload" size="medium" typer={[".pdf"]} value={values.fileUpload} buttonName={values.fileUpload ? "Selected" : "Select"} />
                                                {touched.fileUpload && errors.fileUpload ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.fileUpload}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field>
                                                {values.filePath ? <Button onClick={handleDownload} fluid type="button" color="blue" icon='download' basic></Button> : ""}

                                            </FormUi.Field>
                                            <FormUi.Field width="1" />

                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="4">
                                                <label className="labelName mt-2">Is GST Applicable?</label>
                                            </FormUi.Field>
                                            <FormUi.Field>
                                                <Checkbox
                                                    name={`isGstApplicable`}
                                                    value={values.isGstApplicable}
                                                // inputProps={{disabled: viewmode}}
                                                />
                                            </FormUi.Field>
                                        </FormUi.Group>


                                    </div>
                                </Segment>
                                <Segment>
                                    <div className="ui form">

                                        <Button
                                            type="button"
                                            onClick={() => { setActivateManualPO(false) }}
                                            style={{ borderRadius: "5px 5px 0px 0px" }}
                                            size="small"
                                            toggle
                                            active={!activateManualPO}
                                        >
                                            Active Purchase Order
                                        </Button>
                                        {/* <Button
                                            type="button"
                                            onClick={() => { setActivateManualPO(true) }}
                                            style={{ borderRadius: "5px 5px 0px 0px" }}
                                            size="small"
                                            toggle
                                            active={activateManualPO}

                                        >
                                            New Purchase Order
                                        </Button> */}

                                        {/* FieldArray Component */}
                                        {activateManualPO ?

                                            <>

                                                <Container className="m-2">
                                                    <FormUi.Group >
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">Vehicle Number</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="3">
                                                            <Fieldmik component={VehicleDropdown} name="vehicleNumber" placeholder="Vehicle Number" />
                                                            {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                        </FormUi.Field>
                                                        <FormUi.Field width="2" />
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">PO Reference Number</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="3">
                                                            <Fieldmik name="poReferenceNo" placeholder="Reference Number" />
                                                            {touched.poReferenceNo && errors.poReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.poReferenceNo}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Container>

                                                <AddProduct />

                                            </>

                                            :

                                            <ActivePurchaseOrder editmode={true} />}

                                    </div>
                                </Segment>
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit' className='margin-bottom-70 mt-4'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    vendorPurchaseOrderData: state.getPurchaseOrderReducer.purchaseOrder.data,
    vendorPurchaseOrderLoading: state.getPurchaseOrderReducer.isLoading,
    billData: state.getBillsReducer.bills.data
})

export default connect(mapStatetoProps, { updateBill, getVendorPurchaseOrder, getBills })(AddBill)

// export default AddBill
